import { cache } from '@/container/apollo-client/cache';
import {
  useLiveConferenceCountSubscriptionSubscription,
  useliveConferenceSubscription,
} from '@/types/generated/graphql';
import { CALL_STATUS } from '@shared/constants';
import { Reference, gql } from '@apollo/client';
import { dismissCallAnsweredElsewhereIfCompleted } from './use-conversation-subscriptions/call-answered-elsewhere-handler';

export function useLiveConferenceCountSubscriptionHandler() {
  useLiveConferenceCountSubscriptionSubscription({
    onData: ({ data }) => {
      const liveCount = data?.data?.liveConferenceCount;
      if (!liveCount) return;

      cache.modify({
        fields: {
          liveConferenceCount(existing) {
            return { ...existing, normalCount: liveCount.normalCount, aiCount: liveCount.aiCount };
          },
        },
      });
    },
  });
}

export function useliveConferenceSubscriptionHandler() {
  const { BUSY, FAILED, COMPLETED, CANCELED, NO_ANSWER } = CALL_STATUS;
  const listRemovalStatuses = [BUSY, FAILED, COMPLETED, CANCELED, NO_ANSWER] as string[];
  useliveConferenceSubscription({
    onData: ({ data }) => {
      const liveConference = data?.data?.liveConference;

      //if (!liveConference?.agent) return;

      if (listRemovalStatuses.includes(liveConference?.conversationStatus as string)) {
        dismissCallAnsweredElsewhereIfCompleted(liveConference?.client?.id);
      }

      cache.modify({
        fields: {
          liveConferencesV2(existing) {
            const existingData = existing?.data || [];
            const shouldRemove = listRemovalStatuses.includes(liveConference?.conversationStatus as string);

            if (shouldRemove) {
              return {
                ...existing,
                data: existingData.filter(
                  (item: Reference) => item.__ref !== `LiveConferenceV2Data:${liveConference?.id}`
                ),
              };
            }

            const existingIndex = existingData.findIndex(
              (item: Reference) => item.__ref === `LiveConferenceV2Data:${liveConference?.id}`
            );
            const newRef = cache.writeFragment({
              data: liveConference,
              fragment: gql`
                fragment LiveConferenceItem on LiveConference {
                  id
                }
              `,
            });

            if (existingIndex >= 0) {
              const updated = [...existingData];
              updated[existingIndex] = newRef;
              return { ...existing, data: updated };
            }

            return { ...existing, data: [newRef, ...existingData] };
          },
        },
      });
    },
  });
}
